import { getLocale } from "./locale";
const get_complete_locale = function(options) {
  return Object.assign({}, defaults, getLocale(), options);
};
const defaults = {
  thousands_separator: ",",
  decimal_separator: ".",
  precision: 2
};
const add_thousands_separators = function(value, thousands_separator) {
  return value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands_separator}`);
};
export function format(value, overrides) {
  const options = get_complete_locale(overrides);
  if (options.human && parseInt(value, 10) === value) {
    options.precision = 0;
  }
  if (options.minimum_precision != null) {
    options.precision = Math.max(options.minimum_precision, precision(value));
  }
  const sign = value < 0 ? "-" : "";
  let [number, power] = Math.abs(value).toString().split("e");
  power = power ? +power + options.precision : options.precision;
  [number, power] = Math.round(+`${number}e${power}`).toString().split("e");
  power = power ? +power - options.precision : -options.precision;
  const elements = (+`${number}e${power}`).toFixed(Math.max(options.precision, 0)).split(".");
  const integer = add_thousands_separators(elements[0], options.thousands_separator);
  const [, decimal] = elements;
  const remainder = options.precision < 1 ? "" : `${options.decimal_separator}${decimal}`;
  return `${sign}${integer}${remainder}`;
}
export function parse(text) {
  if (text == null) {
    return 0;
  }
  const { thousands_separator, decimal_separator } = get_complete_locale();
  return +text.toString().split(thousands_separator).join("").replace(decimal_separator, ".").replace(/[^\d.-]/g, "").replace(/\.+$/, "");
}
export function precision(value, overrides) {
  let remainder;
  const options = get_complete_locale(overrides);
  if (isFinite(String(value))) {
    [, remainder] = (value || "").toString().split(".");
  } else {
    [, remainder] = (value || "").toString().split(options.decimal_separator);
  }
  return (remainder != null ? remainder.length : void 0) || 0;
}
export function two_digit_number(number) {
  number = parseInt(number, 10);
  const digits = Math.abs(number);
  const is_negative = number !== digits;
  let formatted_digits = digits >= 10 ? `${digits}` : `0${digits}`;
  if (is_negative) {
    formatted_digits = `-${formatted_digits}`;
  }
  return formatted_digits;
}
